export const blockIconsFileGridView = (
	<span className='material-symbols-outlined'>grid_view</span>
);
